module.exports = __webpack_public_path__ + "assets/img/pierre-cote.c22cd36a.png";